<div>
  <mat-progress-bar mode="query" *ngIf="postStateLoading$ | async" class="mb-5"></mat-progress-bar>
</div>

<div infiniteScroll [fromRoot]="true" [infiniteScrollContainer]="'mat-sidenav-content'" [infiniteScrollDistance]="2"
     (scrolled)="onScroll()"
     [infiniteScrollDisabled]="(postStateLoading$ | async) && (postPagination$ | async)?.hasNextPage === false">

  <div *ngFor="let postState of (postsState$ | async); trackBy: trackByFn">
    <!--    <anms-post [postState]="postState" (createCommentEvent)="createComment($event)"-->
    <!--               (upVotePostEvent)="upVotePost($event)" (downVotePostEvent)="downVotePost($event)"-->
    <!--               (upVoteCommentEvent)="upVoteComment($event)" (downVoteCommentEvent)="downVoteComment($event)"-->
    <!--               (showCommentsEvent)="showComments($event)" (hideCommentsEvent)="hideComments($event)"-->
    <!--               (loadMoreCommentsEvent)="loadMoreComments($event)" (deletePostEvent)="deletePost($event)"-->
    <!--               (deleteCommentEvent)="deleteComment($event)" (favouritePostEvent)="favouritePost($event)"-->
    <!--               (unFavouritePostEvent)="unFavouritePost($event)" (castForPollEvent)="castForPoll($event)"-->
    <!--               (unVotePostEvent)="unVotePost($event)" (echoPostEvent)="echoPost($event)">-->
    <!--    </anms-post>-->
  </div>

  <div *ngIf="!(postStateLoading$ | async)">


    <div class="mt-4 mb-4" *ngIf="!currentUser">
      <img class="w-50 h-50 img-fluid  mx-auto d-block" src="../../../../assets/images/states/no-following.svg"
           alt="no following">
      <h6 class="text-muted text-center p-3">You need to register/login, to view your timeline.</h6>
    </div>


    <div class="mt-4 mb-4" *ngIf="currentUser">
      <img class="w-50 h-50 img-fluid  mx-auto d-block" src="../../../../assets/images/states/no-following.svg" alt="">
      <h6 class="text-muted text-center p-3">Find people to follow then check back here.</h6>
    </div>

    <div class="d-flex justify-content-center m-2">
      <button mat-button routerLink="/auth/login" color="accent" *ngIf="!currentUser">
        Login
        <mat-icon>login</mat-icon>
      </button>
      <button mat-button routerLink="/auth/signup" color="warn" *ngIf="!currentUser">
        SignUp
        <mat-icon>exit_to_app</mat-icon>
      </button>
      <button mat-button routerLink="/discover" color="accent" *ngIf="currentUser">
        Disvover
        <mat-icon>face</mat-icon>
      </button>
    </div>
  </div>
  <!-- <div *ngIf="postStateErrors$ | async">{{postStateErrors$ | async}}</div> -->
</div>
